import { GENDER } from '@/common/constants'
export default {
  title: 'Video Call',
  price: '{price}/min',
  remoteUserLeft: 'The remote user has left the call',
  missingRoomInfo: 'Call information is missing, please try again.',
  timeout: 'No answer',
  refused: 'The call was refused',
  invite: {
    text: 'You are invited to a video call',
    cancel: 'cancel({seconds}s)',
  },
  call: {
    waiting: 'Waiting for the other party to answer...',
    autoCancel: 'Auto-cancel({seconds}s)',
    costLabel: 'Video chat cost:',
  },
  cannotCallTips: {
    inRoom: 'Busy, the other party is in the room',
    busy: `{gender, select,
      ${GENDER.MALE} {He is busy.}
      ${GENDER.FEMALE} {She is busy.}
      other {He/She is busy.}}`,
  },
  error: {
    insufficientCoins: {
      title: 'Insufficient Coins',
      message: 'You don\'t have enough coins to make this call. Please recharge first.',
      recharge: 'Recharge Now',
    },
    insufficientIntimacy: {
      title: 'Insufficient Intimacy',
      message: 'Your intimacy level with this user is not high enough to make a video call.',
    },
    emptyBroadcastPenalty: {
      title: 'Calling Restricted',
      message: 'You are temporarily restricted from making calls due to the anchor system being punished.',
    },
    requireRealName: {
      title: 'Verification Required',
      message: 'Please complete real-name verification before making video calls.',
      verify: 'Verify Now',
    },
    unknown: 'Failed to initiate call. Please try again later.',
    invalidCallInfo: 'Invalid call information',
    answerFailed: 'Failed to answer',
    publishFailed: 'Failed to publish video',
    noRoomInfo: 'Failed to get room information',
    noRtcConfig: 'Failed to get RTC configuration',
    joinFailed: 'Failed to join the room',
  },
  browserNotSupported: 'Your browser does not support video calling',
  deviceNotFound: 'Camera or microphone not found',
  matchFailed: 'Match failed, please try again later',
  matchTimeout: 'Match timeout, please try again',
  hangUpTips: 'Are you sure to end the video call?',
  giftMessage: {
    sent: 'sent',
    to: 'to',
  },
  callTimerLabel: {
    match: 'Match',
    privateCall: 'Private call',
  },
  chargeWarning: 'The call will be charged in {remaining}s.',
  remainVideoTime: 'Remain video time',
}
